// Quick check: the tablet passes back to the grown-up (HOP-26).

import { useState } from 'react'
import { MaskedName } from '@/lib/privacyMask'
import '@/styles/placement-flow.css'

interface ModeQuestionScreenProps {
  learnerName: string
  onAnswer: (childPresent: boolean) => void
  submitting?: boolean
}

function CheckOption({
  label,
  selected,
  onClick,
}: {
  label: string
  selected: boolean
  onClick: () => void
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={['pq-option', selected ? 'is-selected' : ''].filter(Boolean).join(' ')}
    >
      <span className="pq-option__check">
        {selected && (
          <svg
            width="15"
            height="15"
            viewBox="0 0 20 20"
            fill="none"
            stroke="var(--yellow)"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M4 11l4 4 8-9" />
          </svg>
        )}
      </span>
      <span className="pq-option__label">{label}</span>
    </button>
  )
}

export function ModeQuestionScreen({
  learnerName,
  onAnswer,
  submitting = false,
}: ModeQuestionScreenProps) {
  const [selected, setSelected] = useState<boolean | null>(null)
  const ready = selected !== null

  const handleSubmit = () => {
    if (!ready || submitting) return
    onAnswer(selected!)
  }

  return (
    <div className="mode-question-screen">
      <div className="hs-eyebrow mode-question-screen__eyebrow">
        Quick check · for the grown-up
      </div>
      <h1 className="mq-title mode-question-screen__title">
        Was <MaskedName>{learnerName}</MaskedName> reading these words with you just now?
      </h1>

      <div className="mode-question-screen__options">
        <CheckOption
          label="Yes, they read the words out loud"
          selected={selected === true}
          onClick={() => setSelected(true)}
        />
        <CheckOption
          label="No, I answered from what I know"
          selected={selected === false}
          onClick={() => setSelected(false)}
        />
      </div>

      <button
        type="button"
        disabled={!ready || submitting}
        onClick={handleSubmit}
        className="hs-press mq-cta-btn mode-question-screen__cta"
      >
        See <MaskedName>{learnerName}</MaskedName>&rsquo;s results
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          stroke="currentColor"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <path d="M3 10h13M11 4l6 6-6 6" />
        </svg>
      </button>
    </div>
  )
}
